/* eslint-disable import/prefer-default-export */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { IoMdMenu } from "@react-icons/all-files/io/IoMdMenu";
import { FiEye } from "@react-icons/all-files/fi/FiEye";
import { IoLink } from "@react-icons/all-files/io5/IoLink";
import { RiInstagramLine } from "@react-icons/all-files/ri/RiInstagramLine";
import { FiDatabase } from "@react-icons/all-files/fi/FiDatabase";
import { FaLayerGroup } from "@react-icons/all-files/fa/FaLayerGroup";

export const menusConfig = (menuObj, footerSection, page, types) => [
  {
    label: "Edit Layout",
    sections: [
      {
        label: "Main Menu",
        links: [
          {
            data: menuObj?.menu_id || null,
            buttonText: "Edit Main Menu",
            icon: <IoMdMenu fontSize={20} />,
            type: "menu",
            description: "Change the navigation structure and links in the main menu.",
          },
        ],
      },
      {
        label: "Footer Menu",
        links: [
          {
            buttonText: "Edit as seen on",
            icon: <FiEye fontSize={20} />,
            type: "menu",
            data: footerSection?.as_seen_on?.id,
            description: "Change the items within the ‘As seen on’ section.",
          },
          {
            buttonText: "Edit footer links",
            icon: <IoLink fontSize={20}/>,
            type: "menu",
            data: footerSection?.links?.id,
            description: "Change the URL and labels within the footer menu.",
          },
          {
            buttonText: "Edit Social icons",
            icon: <RiInstagramLine fontSize={20} />,
            type: "menu",
            data: footerSection?.social_icons?.id,
            description: "Add or replace social media links.",
          },
        ],
      },
    ],
  },
  {
    label: "Edit Page",
    sections: [
      {
        label: "Page",
        links: [
          {
            data: page.id || null,
            buttonText: "Edit Page",
            icon: <FaLayerGroup fontSize={20} />,
            type: "page",
            description: "Make changes to the page settings.",
          },
        ],
      },
      {
        ...(types.includes(page?.type) && {
          label: "Relations",
          links: [
            {
              ...(types.includes(page?.type) && {
                data: page?.relation,
                buttonText: `Edit ${page?.type} Sites Data`,
                icon: <FiDatabase fontSize={20} />,
                type: page?.type,
                description: "Make changes to Hercules sites data.",
              }),
            },
          ],
        }),
      },
    ],
  },
];
